import styled from 'styled-components';

import { Typography } from 'src/typography';

export const EmptyStateCard = styled.div`
  align-items: center;
  border: 1px dotted var(--dcm-wallet-activity-empty-border-color, ${({ theme }) => theme.colors.grey[90]});
  border-radius: var(--dcm-wallet-activity-empty-border-radius, 8px);
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 32px 16px;
  text-align: center;
`;

export const EmptyStateTitle = styled(Typography.Body)`
  color: var(--dcm-color-text-primary, ${({ theme }) => theme.colors.primaryBlack});
`;

export const EmptyStateSubtitle = styled(Typography.Body)`
  color: var(--dcm-wallet-activity-empty-subtitle-color, ${({ theme }) => theme.colors.grey[45]});
`;
